import React from 'react'
import { useNavigate } from 'react-router-dom'

function Index({ lable, leftitem, back }) {
    const navigate = useNavigate();
    return (
        <div className='head-main d-flex col-4 justify-content-between'>
            <div className="d-flex align-items-center">
                <i className="fas fa-arrow-right" onClick={() => {
                    if (back) {
                        back();
                        return;
                    }
                    navigate(-1)
                }}></i>
                <p>{lable}</p>
            </div>
            {leftitem}
        </div>
    )
}

export default Index